/* eslint-disable */
import React from 'react';
import { ReferenceField, TextField, useTranslate } from 'react-admin';
import { NumberField } from '../../../../base/components/ra/fields';
import resourceSlug, { REPORT_TYPES } from '../../../../constant/resource-slug';
import { LIST_REPORTS } from '../../report-winners.list';
import CustomReportTable from '../../../../base/components/reports/CustomReportTable';
import TranslatableField from '../../../../base/components/ra/fields/translatable.field';
import CustomLinkField from '../../../../base/components/ra/fields/customLink.field';
import { transformIdValue } from '../../../../services/util/stringUtil';
import { ID_EMPTY } from '../../../../constant';
import ReportWinnersLink from './ReportWinnersLink';
import BaseCurrencyField from '../../../../base/components/reports/ReportTable/BaseCurrencyField';
import { useReportContext } from '../../../../base/components/reports/ReportLayout';

const PrepaidTable = () => {
  const translate = useTranslate();
  const { appliedFilters } = useReportContext();
  return (
    <CustomReportTable
      title={translate('resources.report.prepaid')}
      reportType={REPORT_TYPES.PREPAID}
      reportList={LIST_REPORTS}
      resource={resourceSlug.REPORT_WINNERS}
    >
      <ReferenceField link="show" source="group" reference="group" label="resources.group.name">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="brand" reference="brand" label="resources.brand.name">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link="show" source="gameId" reference="game" label="resources.game.fields.gameId">
        <TextField source="gameId" />
      </ReferenceField>
      <TranslatableField label="resources.report.fields.gameName" source="game" />
      <CustomLinkField
        sortable={false}
        source="playerId"
        href={(record) => `/#/${resourceSlug.PLAYER}/${record.playerId}/show`}
        title={(record) => (record.playerId ? transformIdValue(record.playerId) : ID_EMPTY)}
      />
      <TextField label="resources.report.fields.nativeId" source="nativeId" sortable={false} />
      <NumberField label="resources.report.fields.betCount" source="betCount" sortable />
      <TextField label="resources.report.fields.currencyType" source="currencyType" sortable={false} />
      <ReferenceField
        link="show"
        source="currency"
        reference="currency"
        label="resources.currency.name"
        sortable={false}
      >
        <TextField source="code" />
      </ReferenceField>
      {Boolean(appliedFilters.consolidated) && <BaseCurrencyField label="resources.report.fields.baseCurrency" />}
      <TextField label="resources.report.fields.betAmount" source="betAmount" sortable />
      <TextField label="resources.report.fields.wonAmount" source="wonAmount" sortable />
      <TextField label="resources.report.fields.winnings" source="winnings" sortable />
      <ReportWinnersLink label={translate('ra.field.action')} sortable={false} type={REPORT_TYPES.PREPAID} />
    </CustomReportTable>
  );
};

export default PrepaidTable;
